import { ReactNode, ElementType } from 'react';

import { Typography, type TypographyVariantProp } from '@natu/ui/Typography';

interface NodeHeadingProps {
  level: 1 | 2 | 3 | 4 | 5 | 6;
}

interface Heading {
  className: string;
  tag: ElementType;
  variant: TypographyVariantProp;
}

const headings: Heading[] = [
  {
    className: '',
    tag: 'h1',
    variant: ['display-sm', 'display-md'],
  },
  {
    className: 'mt-10 mb-6',
    tag: 'h2',
    variant: ['display-xs', 'display-sm', 'display-md'],
  },
  {
    className: '',
    tag: 'h3',
    variant: ['text-xl', 'display-xs'],
  },
  {
    className: '',
    tag: 'h4',
    variant: ['text-lg', 'text-xl'],
  },
  {
    className: '',
    tag: 'h5',
    variant: ['text-md', 'text-lg'],
  },
  {
    className: '',
    tag: 'h6',
    variant: ['text-sm', 'text-md'],
  },
];

export const NodeHeading = (children: ReactNode, { level }: NodeHeadingProps) => {
  const { className, tag, variant } = headings[level - 1];

  return (
    <Typography className={className} component={tag} variant={variant}>
      {children}
    </Typography>
  );
};
